import React, { Component } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AppAccessDenied from "./components/Errors/AppAccessDenied";
import AwafError from "./components/Errors/AwafError";
import Error from "./components/Errors/Error";
import DeadlineError from "./components/Errors/DeadlineError";
import Error404 from "./components/Errors/Error404";
import AuthenticationFail from "./components/Errors/AuthenticationFail";
import About from "./components/About";
import HowToSubmit from "./components/HowToSubmit";
import ContactUs from "./components/ContactUs";
import Faq from "./components/Faq";
import AccountLocked from "./components/Errors/AccountLocked";
import Layout from "./components/Layout";
import Home from "./components/Home";
import { FetchData } from "./components/FetchData";
import SubmitProposal from "./components/secure/SubmitProposal";
import SubmitSpecialProposal from "./components/secure/SubmitSpecialProposal";
import ReviseProposal from "./components/secure/ReviseProposal";
import { Counter } from "./components/Counter";
import LoginForm from "./components/LoginForm";
import Logout from "./components/Logout";
import auth from "./services/authService";
//import RefreshToken from "./components/RefreshToken";
import NotFound from "./components/NotFound";
import ProtectedRoute from "./components/common/protectedRoute";
import { Solicitation } from "./components/secure/Solicitation";
import { StaffManagement } from "./components/secure/StaffManagement";
import "react-toastify/dist/ReactToastify.css";
import IcRoleService from "./services/icRoleService";
import "./custom.css";

import OtpLogin from "./components/OtpLogin"
import SubmissionHistory from "./components/secure/SubmissionHistory";
import { datadogRum } from '@datadog/browser-rum';

import analytics from "./services/analytics";

var domain = window.location.host.split(".")[0];
var env = 'local';
var rumStart = false;
switch (domain) {
    case 'ecps-ext-dev':
        env = 'dev';
        break;
    case 'ecps-ext-stg':
        env = 'stage';
        break;
    case 'ecps-qa':
        env = 'qa';
        rumStart = true;
        break;
    case 'ecps':
        env = 'production';
        rumStart = true;
        break;
    default:
        env = 'local';
        break;
}

function isDatadogRumInitialized() {
    try {
        return typeof datadogRum.getInitConfiguration === "function" && !!datadogRum.getInitConfiguration();
    } catch {
        return false;
    }
}

export default class App extends Component {
    static displayName = App.name;
    state = {};

    async componentDidMount() {

        if (rumStart && !isDatadogRumInitialized()) {
            datadogRum.init({
                    applicationId: '6e92494d-63d1-445f-aa17-8e962bfedcaa',
                    clientToken: 'pub8434878429539a8172bc1559b2bd7e92',
                    site: 'ddog-gov.com',
                    service: 'eCPS.External.WebUI',
                    project: 'eCPS',
                    env: env,
                    sessionSampleRate: 100,
                    sessionReplaySampleRate: 100,
                    trackUserInteractions: true,
                    defaultPrivacyLevel: 'allow',

                    beforeSend: (event, context) => {
                        if (event.type === 'resource' && event.resource.type === 'xhr') {
                            event.context = {
                                ...event.context,
                                responseHeaders: context.response?.headers ?? "",
                                xhrresponse: context.xhr.response
                            };
                        }
                    }
                }
            );
        }

        if (rumStart && isDatadogRumInitialized()) {
            datadogRum.startSessionReplayRecording();
            datadogRum.setGlobalContextProperty("domain", domain);
        }

        const user = auth.getCurrentUser();
        if (user && isDatadogRumInitialized()) {
            datadogRum.setUser({
                id: user.appId,
                name: user.firstName + " " + user.lastName,
                email: user.email,
                plan: 'premium'
            });
        }

        analytics.initAnalytics();

        this.setState({ user: user });
    }


    routes = function (user) {
        return (
            <React.Fragment>
                <ToastContainer position="top-center" autoClose={5000} />

                <Layout>
                    <Routes>
                        <Route path="/submitProposal/:id" element={<ProtectedRoute><SubmitProposal /></ProtectedRoute>} />
                        <Route path="/submitSpecialProposal/:id/:specialInviteId" element={<ProtectedRoute><SubmitSpecialProposal /></ProtectedRoute>} />
                        <Route path="/reviseProposal/:id" element={<ProtectedRoute><ReviseProposal /></ProtectedRoute>} />
                        <Route path="/submissionHistory" element={<ProtectedRoute><SubmissionHistory /></ProtectedRoute>} />
                        <Route path="/home" element={<Home />} />
                        <Route path="/" element={<Home />} />
                        <Route path="/About" element={<About />} />
                        <Route path="/HowToSubmit" element={<HowToSubmit />} />
                        <Route path="/contactUs" element={<ContactUs />} />
                        <Route path="/Faq" element={<Faq />} />
                        <Route path="/otpLogin/:str" element={<OtpLogin />} />
                        <Route path="/otpLogin" element={<OtpLogin />} />
                        <Route path="/logout" element={<Logout />} />
                        <Route path="/accountLocked" element={<AccountLocked />} />
                        <Route path="/appAccessDenied" element={<AppAccessDenied />} />
                        <Route path="/error" element={<Error />} />
                        <Route path="/deadlineerror" element={<DeadlineError />} />
                        <Route path="/authenticationFail" element={<AuthenticationFail />} />
                        <Route path="/AwafError/:id?" element={<AwafError />} />
                        <Route path="*" element={<Error404 />} />
                    </Routes>
                </Layout>
            </React.Fragment>
        )
    }

   render() {
      const { user } = this.state;
      //console.log(user);
      return (this.routes(user));
   }
}

